import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plug, Check } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '../ui/card';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConnectionRequests = ({ token }) => {
  const [reqs, setReqs] = useState([]);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const load = () => axios.get(`${API}/admin/connection-requests`, auth).then((r) => setReqs(r.data.requests)).catch(() => {});
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const done = async (id) => {
    try { await axios.post(`${API}/admin/connection-requests/${id}/done`, {}, auth); toast.success('Marked as done'); load(); }
    catch { toast.error('Could not update'); }
  };

  if (!reqs.length) return null;
  return (
    <Card className="p-6 bg-white border-slate-200 mb-6" data-testid="admin-connection-requests">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-cyan-100 flex items-center justify-center"><Plug className="w-5 h-5 text-cyan-700" /></div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">"Have us connect it" requests</h2>
          <p className="text-sm text-slate-500">Pro customers waiting for you to connect their stock and price system</p>
        </div>
      </div>
      <div className="space-y-3">
        {reqs.map((r) => (
          <div key={r.id} className="flex flex-wrap items-start justify-between gap-3 rounded-lg border border-slate-200 p-3" data-testid={`admin-connection-request-${r.id}`}>
            <div className="text-sm">
              <p className="font-semibold text-slate-900">{r.business_name} · {r.system_name}</p>
              <p className="text-slate-500">{r.email}{r.website ? ` · ${r.website}` : ''}</p>
              {r.details && <p className="text-slate-600 mt-1">{r.details}</p>}
            </div>
            <Button size="sm" variant="outline" onClick={() => done(r.id)} data-testid={`admin-connection-request-done-${r.id}`}><Check className="w-4 h-4 mr-1" /> Done</Button>
          </div>
        ))}
      </div>
    </Card>
  );
};
